/*
 * @Author: dongzhuo
 * @Date: 2021-01-04 11:38:06
 * @LastEditTime: 2021-05-10 14:54:45
 * @FilePath: \welink-template\src\utils\index.js
 * @Description:
 */
const currency = require("currency.js");
const dayjs = require("dayjs");
import _this from "@/main";

export default {
  install(Vue) {
    /**
     * @description 跳转路由（刷新单页面）
     * @param {String} path 页面路由
     * @param {Object} query 携带的参数
     */
    Vue.prototype.$refreshRoute = (path, query) => {
      _this.$store.dispatch("tags/refreshView", path).then(() => {
        _this.$router.replace({
          path: "/redirect" + path,
          query
        });
      });
    };
    /**
     * @description 跳转页面（特别是详情页等带参数的都采用该方式）
     * @param {String} path 路由地址
     * @param {Object} query 携带参数
     * @param {Boolean} isReplace 是否想栈中加记录
     */
    Vue.prototype.$go = (path, query = {}, isReplace = false) => {
      if (isReplace) {
        _this.$router.replace({ path, query });
      } else {
        _this.$router.push({ path, query });
      }
    };
    /**
     * @description 回退到目标页面(一般用于详情等二级页回退至列表页。可能需要关闭当前页签，或者刷新目标页面)
     * @param {String} path 路由地址
     * @param {Boolean} isClose 是否关闭当前页面
     * @param {Boolean} isRefresh 是否刷新目标页面
     */
    Vue.prototype.$back = (path, isClose = false, isRefresh = false) => {
      if (isClose) {
        _this.$store.dispatch("tags/delView", _this.$route.path);
      }
      if (isRefresh) {
        _this.$refreshRoute(path);
      } else {
        _this.$router.push({ path });
      }
    };
    /**
     * @description 返回参数
     */
    Vue.prototype.$query = () => {
      return _this.$route.query;
    };
    /**
     *
     * @param {number} value 金额
     * @param {number} precision 精度
     * @description 金额格式化
     */
    Vue.prototype.$currency = (value, precision = 2) => {
      if (value) {
        return currency(value, {
          precision: precision
        }).format();
      } else {
        return value;
      }
    };
    /**
     *
     * @param {Date} value
     * @param {String} format
     * @description 日期格式化
     */
    Vue.prototype.$dateFormat = (value, format = "YYYY.MM") => {
      if (value) {
        return dayjs.unix(value).format(format);
      } else {
        return value;
      }
    };
    /** *
     * 成功弹框
     */
    Vue.prototype.$success = msg => {
      _this.$message({
        message: msg,
        type: "success"
      });
    };

    /**
     * 警告弹框
     */
    Vue.prototype.$warning = (msg, options) => {
      _this.$message({
        message: msg,
        type: "warning",
        ...options
      });
    };


    /**
     * 错误弹框
     */
    Vue.prototype.$error = msg => {
      _this.$message.error(msg);
    };
    /**
     * @description 用于处理按钮权限
     * @param {String} perm
     */
    Vue.prototype.$hasPerm = perm => {
      const btnPermList = _this.$store.state.user.userInfo.userBtnPerms || [];
      // 所有权限标识
      // const ENV = process.env.NODE_ENV;
      // 权限标识为空。则默认显示.若需要权限则需要配置响应标识
      const hasExsit = perm ? btnPermList.includes(perm) : true;
      // return hasExsit || "development";
      return hasExsit
    };
    /**
     * @description 模态窗
     * @param {String} msg
     * @param {String} type
     * @param {String} showCancelButton
     * @param {String} showConfirmButton
     */
    Vue.prototype.$modal = async (
      msg,
      type = "warning",
      showCancelButton = true,
      showConfirmButton = true
    ) => {
      return _this.$confirm(msg, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: type,
        showCancelButton: showCancelButton,
        showConfirmButton: showConfirmButton
      });
    };
    /**
     *
     * @param {Date} value
     * @param {String} format
     * @description 日期格式化
     */
    Vue.prototype.$format = (value, format = 'YYYY-MM-DD') => {
      if (value) {
        return dayjs.unix(value).format(format)
      } else {
        return value
      }
    }
    /**
     * @description 设置焦点
     * @param {} el(为el-table中的index+当前列的prop)
     */
    Vue.prototype.$setFocus = (el, isAutoComplete = false) => {
      if (isAutoComplete) {
        // 对auto-complete-table进行设置焦点
        $(`${el} .el-popover__reference-wrapper .el-input__inner`).focus();
      } else {
        // 对只有一个el-input进行设置焦点
        $(el)
          .find(".el-input__inner")
          .focus();
      }
    };
    /**
     * @description 防抖函数
     * @param {Function} handle
     * @param {Number} delay
     */
    Vue.prototype.$debounce = (func, delay) => {
      let timer = null;
      if (timer !== null) clearTimeout(timer);
      timer = setTimeout(func, delay);
    };

    /**
     * @description 从数组中某个位置删除某项
     * @param {Array} target
     * @param {Number} index
     */
    Vue.prototype.$deleteItem = (target = [], index) => {
      target.splice(index, 1);
    };
    /**
     * 校验密码 6-16位字母+数字组合
     */
    Vue.prototype.$validatePassWord = function (str) {
      const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
      return reg.test(str);
    };

    /**
     * @description 清空对象
     * @param {Object} data
     * @param {Object} 默认值对象。特殊的情况比如boolean等
     */
    Vue.prototype.$resetForm = (data, defaultData = {}) => {
      // 空或者非对象
      if (!data || typeof data !== "object") {
        return data;
      }
      Object.keys(data).forEach(key => {
        if (data[key] instanceof Array) {
          // 数组
          data[key] = defaultData[key] ? defaultData[key] : [];
        } else if (data[key] instanceof Object) {
          // 对象
          data[key] = defaultData[key] ? { ...defaultData[key] } : {};
        } else if (
          typeof data[key] == "string" ||
          typeof data[key] == "number"
        ) {
          // 字符串或数值类型
          data[key] = defaultData[key] ? defaultData[key] : "";
        } else if (typeof data[key] == "boolean") {
          // 布尔
          data[key] = defaultData[key];
        }
      });
    };
  }
};
